import ZoneFolderIcon from './component'

export default ZoneFolderIcon
